export default "__VITE_ASSET__8cf94da4__"